// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { EMPTY_STRING } from '~/utils/constants/common';
import { IFormPackage } from '~/utils/interface/package';

export const schema = (t: TFunction): yup.ObjectSchema<IFormPackage> => {
  return yup.object().shape({
    title: yup
      .string()
      .trim()
      .required(t('common_validate_field_required', { ns: 'common/base' })),
    rentalPrice: yup
      .string()
      .trim()
      .required(t('common_validate_field_required', { ns: 'common/base' })),
    categoryId: yup.string().trim().optional(),
    categoryName: yup.string().trim().optional(),
    note: yup.string().trim().optional(),
    description: yup.string().trim().optional(),
    isTaxable: yup.boolean().optional(),
    packageItems: yup
      .array()
      .required(t('common_validate_field_required', { ns: 'common/base' }))
      .min(1, t('common_validate_field_required', { ns: 'common/base' })),
    packageImage: yup.object().optional(),
    productItems: yup.array().optional(),
    selectIdProductInventory: yup.string().trim().optional(),
    selectIdVariantInventory: yup.string().trim().optional(),
    selectIdProductSetProduct: yup.string().trim().optional(),
    selectIdVariantSetProduct: yup.string().trim().optional(),
    selectQuantitySetProduct: yup.number().optional(),
    deleteProduct: yup.string().trim().optional(),
    deleteItemIds: yup.array().optional(),
    isDeleteImage: yup.boolean().optional(),
    isShowItem: yup.boolean().optional(),
  });
};

export const defaultValuesPackageForm: IFormPackage = {
  title: EMPTY_STRING,
  categoryId: EMPTY_STRING,
  categoryName: EMPTY_STRING,
  rentalPrice: EMPTY_STRING,
  note: EMPTY_STRING,
  isShowItem: false,
  description: EMPTY_STRING,
  isTaxable: false,
  packageImage: {},
  packageItems: [],
  productItems: [],
  selectIdProductInventory: EMPTY_STRING,
  selectIdVariantInventory: EMPTY_STRING,
  selectIdProductSetProduct: EMPTY_STRING,
  selectIdVariantSetProduct: EMPTY_STRING,
  selectQuantitySetProduct: 0,
  deleteProduct: EMPTY_STRING,
  deleteItemIds: [],
  isDeleteImage: false,
};
